<script setup lang="ts">
import {computed, defineProps, defineEmits} from 'vue'
import { NCard, NSpace, NTag, NButton, NIcon, NSkeleton } from 'naive-ui'
import { OpenInNewFilled } from '@vicons/material'

const props = defineProps([
  'title',
  'detailsStructure',
  'data'
])

defineEmits(['closeCard'])

const loading = computed(() => {
  return typeof props.data == 'undefined'
})

</script>

<template>
  <n-card size="huge" :title="title ?? 'Details'" closable @close="$emit('closeCard')" :bordered="false">
    <n-space :size="30" vertical>
      <template v-for="(field, i) in detailsStructure" :key="i">
        <div v-if="typeof data != 'undefined' && data[field.key] && data[field.key].length > 0" class="data-set">
          <n-space size="small" vertical>
            <p class="data-key body-text text-w-bold text-uppercase">{{ field.label }}</p>

            <n-skeleton v-if="loading" height="28px" width="100%" :sharp="false" />

            <template v-else>
              <p v-if="field.type === 'string'" class="data-value body-text-md text-w-light">
                {{ data[field.key] }}
              </p>
              <div v-else-if="field.type === 'object'" class="data-value">
                <n-space>
                  <n-tag v-for="(skill, key) in data[field.key]" :key="key" type="info" :bordered="false">
                    {{ skill.title }}
                  </n-tag>
                </n-space>
              </div>
              <a v-else-if="field.type === 'link'" class="data-value simple-link" :href="data[field.key]" target="_blank">
                <n-button tertiary class="width-50" :focusable="false" size="small" icon-placement="right">
                  <template #icon>
                    <n-icon>
                      <open-in-new-filled></open-in-new-filled>
                    </n-icon>
                  </template>
                  Open link
                </n-button>
              </a>
            </template>
          </n-space>
        </div>
      </template>
    </n-space>
  </n-card>
</template>

<style lang="scss">

</style>